// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#support-register[data-v-87185d2e]{max-width:1280px;margin-left:auto;margin-right:auto}#support-register .cancel-btn[data-v-87185d2e],#support-register .register-btn[data-v-87185d2e]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
